import produce from 'immer';
import {
    DOCUMENT_CREATE_REQUEST,
    DOCUMENT_CREATE_SUCCESS,
    DOCUMENT_CREATE_ERROR
} from '../actions/actionTypes';

const initialState = {
    creating: false
};

const documentReducer = (state = initialState, action) => {
    return produce(state, draft => {
        switch (action.type) {
            case DOCUMENT_CREATE_REQUEST:
                draft.creating = true;
                break;

            case DOCUMENT_CREATE_SUCCESS:
            case DOCUMENT_CREATE_ERROR:
                draft.creating = false;
                break;

            // no default
        }
    });
};

export default documentReducer;
